import { Swiper, Pagination } from 'swiper';

const breakpoint = window.matchMedia('(min-width: 1224px)');
Swiper.use([Pagination]);

let sliders;

function enableSwiper() {
  sliders = new Swiper('.swiper-grid .swiper-container:not(.no-swiper)', {
    loop: false,
    spaceBetween: 10,
    centeredSlidesBounds: true,
    centeredSlides: true,
    slidesPerView: 1.2,
    a11y: true,
    keyboardControl: true,
    grabCursor: true,
    autoHeight: false,
    pagination: {
      el: '.swiper-grid .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      650: {
        slidesPerView: 2.2,
        spaceBetween: 20,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },

      768: {
        centeredSlides: false,
        centeredSlidesBounds: false,
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
    },
  });
}

function swiperBreakpointChecker() {
  // if larger viewport and multi-row layout needed

  if (breakpoint.matches === true) {
    if (Array.isArray(sliders)) {
      for (let index = 0; index < sliders.length; index += 1) {
        const mySwiper = sliders[Number(index)];

        if (mySwiper !== undefined) mySwiper.destroy(true, true);
      }
    } else if (sliders !== undefined) sliders.destroy(true, true);
  } else {
    enableSwiper();
  }
}

breakpoint.addEventListener('change', swiperBreakpointChecker);

swiperBreakpointChecker();
